import { Injectable } from '@angular/core';
import { TrackingSource } from '@shared/core/types/tracking';
import { VimCoreTrackingData, VimCoreTrackingService } from '../../../../vendor/tracking';

@Injectable({
  providedIn: 'root',
})
export class TrackingService extends VimCoreTrackingService {
  send(source: TrackingSource, event: string, data: VimCoreTrackingData = {}) {
    const prevSource = this.getSource();

    this.setSource(source);
    this.track(event, data);

    this.setSource(prevSource);
  }
}
